module.exports = __webpack_public_path__ + "img/charge_status_98.6c70db90.png";